export const AB_KEY = 'absystem';

export const ActionTypes = {
    LOADING_ASSIGNMENTS: '@@abservice/LOADING_ASSIGNMENTS',
    RECEIVED_ASSIGNMENTS: '@@abservice/RECEIVED_ASSIGNMENTS',
    ASSIGNMENTS_ERROR: '@@abservice/ASSIGNMENTS_ERROR',
    TRACKED_CONVERSION: '@@abservice/TRACKED_CONVERSION',
    CONVERSION_ERROR: '@@abservice/CONVERSION_ERROR',
};

export const OPTIMIZELY_PROJECT = 'default';
export const OPTIMIZELY_PROJECT_ID = '8426652696';

export const ABGoals = {
    MADE_IT_TO_PROFILE: 'MadeItToProfile',
};

export const MY_ACCOUNT_TEXT = 'My account';
export const LOGIN_SIGNUP_TEXT = 'Log in / Sign up';
